<div class="modal-header">
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
      <g fill="none" fill-rule="evenodd">
        <path fill="#979797" fill-rule="nonzero" d="M17.566 0v.73c.468 0 .934.018 1.397.056l.06-.726c-.48-.04-.966-.06-1.457-.06zm2.786.96c.46.076.917.172 1.367.287l.18-.706c-.312-.08-.628-.151-.946-.214l-.48-.087-.12.72zm2.728.696c.44.153.873.325 1.299.514l.296-.666c-.295-.131-.594-.255-.898-.37L23.32.968l-.24.688zm2.959.528l-.354.638c.408.226.806.469 1.194.728l.405-.606c-.403-.27-.819-.524-1.245-.76zm1.937 2.166c.365.29.719.595 1.059.914l.499-.532c-.237-.222-.48-.437-.728-.646l-.377-.307-.453.571zm2.071 1.948c.312.347.609.706.89 1.078l.581-.44c-.196-.26-.399-.512-.608-.76l-.32-.365-.543.487zM32.393 8.2l-.617.388c.248.394.48.799.694 1.213l.647-.335c-.224-.433-.465-.856-.724-1.266zm.624 2.765c.181.428.345.865.49 1.308l.693-.227c-.102-.31-.211-.615-.33-.917l-.182-.449-.671.285zm.877 2.686c.106.453.193.91.262 1.373l.721-.107c-.048-.323-.104-.642-.17-.96l-.103-.472-.71.166zm.411 2.808c.021.339.032.68.032 1.022l-.004.395.729.016.004-.393-.008-.544-.025-.54-.728.044zm-.06 2.813c-.05.464-.117.926-.204 1.382l.716.137c.06-.317.112-.636.155-.958l.058-.485-.726-.076zm-.526 2.754c-.126.45-.27.892-.432 1.328l.683.255c.113-.303.217-.609.313-.919l.138-.468-.702-.196zm-.995 2.658c-.2.421-.417.834-.651 1.236l.63.367c.162-.28.318-.564.465-.853l.215-.437-.659-.313zm-1.39 2.395c-.267.382-.55.753-.847 1.112l.562.465c.206-.25.406-.504.599-.765l.284-.395-.598-.417zm-1.812 2.181c-.327.332-.668.651-1.02.955l.475.553c.246-.212.485-.43.719-.655l.346-.342-.52-.51zm-2.17 1.86c-.379.273-.768.53-1.168.77l.376.624c.278-.167.551-.341.82-.523l.398-.279-.426-.591zm-2.392 1.436c-.418.206-.844.394-1.278.564l.266.679c.303-.119.601-.246.896-.38l.438-.208-.322-.655zm-2.546 1.003c-.445.134-.897.25-1.353.346l.151.714c.319-.068.635-.144.947-.229l.466-.133-.21-.698zm-2.772.584c-.462.057-.926.095-1.394.113l.03.729c.326-.013.65-.035.972-.066l.48-.053-.088-.723zm-2.828.11c-.467-.02-.932-.06-1.392-.119l-.093.723c.32.041.641.073.965.096l.488.029.032-.729zm-2.776-.355c-.457-.098-.908-.214-1.354-.35l-.211.698c.308.094.62.18.936.256l.476.11.153-.714zm-2.7-.823c-.434-.173-.859-.364-1.275-.573l-.327.652c.29.145.583.282.88.41l.45.188.271-.677zm-2.564-1.292c-.397-.244-.783-.505-1.158-.782l-.433.586c.26.193.526.378.798.556l.41.26.383-.62zm-2.206-1.623c-.352-.305-.69-.626-1.016-.96l-.522.51c.226.231.458.457.697.677l.363.324.478-.55zm-1.985-2.044c-.295-.36-.575-.733-.84-1.117l-.6.413c.184.268.375.53.573.786l.303.38.564-.462zm-1.625-2.374c-.23-.405-.442-.82-.637-1.243l-.662.304c.136.296.28.587.43.873l.234.425.635-.359zM.066 22.37L0 22.388l.066.232v-.25zm1.77.957c-.163-.436-.306-.88-.43-1.329l-.703.195c.087.314.182.624.286.93l.162.458.684-.254zm-.755-2.726c-.085-.457-.152-.918-.199-1.383l-.725.073c.033.325.075.648.125.967l.082.477.717-.134zM.068 17.787l.73-.012-.003-.27c0-.382.013-.759.038-1.134l-.728-.048-.03.586-.008.735.001.143zm.915-2.807c.07-.462.159-.92.266-1.372l-.71-.169c-.074.314-.14.63-.197.95l-.08.482.721.109zm.652-2.735c.146-.443.31-.879.492-1.307l-.67-.286c-.127.298-.245.599-.356.904l-.159.46.693.23zm1.12-2.62c.22-.412.456-.813.708-1.205l-.612-.395c-.176.271-.344.548-.504.83l-.235.427.644.342zm1.494-2.32c.283-.37.582-.728.896-1.073l-.54-.49c-.218.24-.43.486-.634.737l-.3.382.578.444zm1.912-2.1c.342-.318.696-.62 1.063-.908l-.45-.574c-.255.2-.505.407-.748.621l-.361.326.496.534zM8.419 3.44c.39-.255.792-.493 1.202-.714l-.346-.642c-.286.154-.567.316-.844.485l-.41.26.398.61zm2.363-1.283c.425-.189.859-.36 1.3-.512l-.239-.689c-.307.107-.611.221-.91.344l-.447.19.296.667zm2.672-.921c.45-.114.907-.209 1.368-.284l-.119-.72c-.322.053-.64.115-.956.185l-.472.112.179.707zm2.74-1.184l.057.727c.428-.033.858-.05 1.29-.05V0c-.453 0-.902.019-1.346.053z" transform="translate(-935 -219) translate(440 199) translate(203 20) translate(292)" />
        <path stroke="#343434" stroke-linecap="square" stroke-width=".98" d="M14.827 14.112l6.06 6.061m0-6.06l-6.06 6.06" transform="translate(-935 -219) translate(440 199) translate(203 20) translate(292)" />
      </g>
    </svg>
  </button>
  <!-- <div class="modal-logo">
    <img src="/images/teem-logo.svg" alt="">
  </div> -->
</div>

<div class="modal-body" dir="rtl"> 
  
  <div class="text-center">
    <img src="/images/teemarabic.png" height="70px" alt="" loading="lazy">
    <h3 > عــــقــــد اتــــفــــاق </h3>
  </div>

  <div>
    <p>
      أبرمت هذه الاتفاقية (يشــار الیها وكافة ملحقاتها باســم ”الاتفاقية“)  بین كل من منصة تيم ، وهو علامة تجارية لشركة حلول الجادة لتقنية المعلومات. س.ت رقم  4030220095  (ويشار الیها فما بعد اسم تيم) و شركة <strong>{{userDetails?.business_name}}</strong> والمبينة معلوماتها أدناه والمشار إليه لاحقا "بالطرف الثاني أو المشترك" 
    </p>

    <br/><br/><br/>
    
    <table class="table table-bordered">
      <tr>
        <th colspan="2"> تفاصيل جهة اتصال المطعم/المتجر </th>
        <th colspan="2"> تفاصيل فاتورة المطعم /المتجر: </th>
      </tr>

      <tr>
        <td class="label"> أسم المطعم /المتجر: </td>
        <td class="value">{{contractFromData?.store_name}}</td>
        <td class="label"> مالك الحساب المصرفي: </td>
        <td class="value">{{contractFromData?.bank_holder_name}}</td>
      </tr>

      <tr>
        <td class="label"> السم التجاري: </td>
        <td class="value">{{contractFromData?.trade_name}}</td>
        <td class="label"> رقم اليبان: </td>
        <td class="value">{{contractFromData?.iban}}</td>
      </tr>

      <tr>
        <td class="label"> رقم السجل التجاري: </td>
        <td class="value">{{contractFromData?.cr_number}}</td>
        <td class="label"> اسم البنك: </td>
        <td class="value">{{bankName}}</td>
      </tr>

      <tr>
        <td class="label"> العنوان: </td>
        <td class="value">{{contractFromData?.address}}</td>
        <td class="label">  البريد الإلكتروني للفاتورة:  </td>
        <td class="value">{{contractFromData?.invoice_email}}</td>
      </tr>

      <tr>
        <td class="label"> أسم المالك/المدير: </td>
        <td class="value">{{contractFromData?.manager_name}}</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td class="label">  المنصب: </td>
        <td class="value">{{jobTitle}}</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td class="label">  رقم الهوية: </td>
        <td class="value">{{contractFromData?.identification_number}}</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td class="label"> البريد اللكتروني: </td>
        <td class="value">{{userDetails?.email}}</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td class="label"> التلفون: </td>
        <td class="value">{{userDetails?.phone}}</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td class="label"> الرقم الضريبي: </td>
        <td class="value">{{userDetails?.tax_number}}</td>
        <td></td>
        <td></td>
      </tr>
    </table>

    <p> <strong> التمهيد : </strong> </p>
    <p>
      حيث أن الطرف الأول هو شركة رائدة في مجال استقبال الطلبات والتوصيل عبر الإنترنت وتملك منصة "تيم"، وحيث أن الطرف الثاني شركة تحمل اسم العلامة التجارية <strong>{{userDetails?.business_name}}</strong> وترغب في الاشتراك بمنصة الطرف الأول والاستفادة من خدماتها، عليه، فقد تم التفاق بين الطرفين وهما بكامل أهليتهما المعتبرة شرعا ونظاما على البنود التالية: 
    </p>

    <p> <strong> اولاً - التزامات وحقوق الطرف الأول:  </strong> </p>
    <p>1-يلتزم بتفعيل حساب في المنصة يتضمن “داشبورد" للطرف الثاني، وشرح آلية إستخدامها لتمكينه من إستقبال وتتبع الطلبات.</p>
    <p>2-يلتزم الطرف الأول بتقديم خدمات استلام الطلب من الطرف الثاني وتسليمه بتوصيله إلى العميل</p>
    <p>3-يتحمل الطرف الأول مسؤولية الربط مع بوابات الدفع للتحصيل من العملاء “المستخدمين".</p>
    <p>4-يكون للطرف الأول الحق في تحديد أو تغيير مبلغ التوصيل في أي وقت، وتقديم الخصومات لعملائه وذلك دون رجوعه للطرف الثاني..</p>
    <p>5-يقوم الطرف الأول بتعويض الطرف الثاني وبحد اقصى 150 ريال سعودي، وذلك عن قيمة تكلفة الطلب الذي يتم تحضيره دون وصول السائق لاستلامه. </p>

    <p> <strong> ثانياً- التزامات الطرف الثاني: </strong> </p>
    <p>1-يلتزم الطرف الثاني بتزويد الطرف الأول ببيانات الفروع ومواقعها وقائمة منتجاته بأسعارها لعرضها في المنصة، كما يقوم بالتأكد من أن كافة البيانات الخاصة به مطابقة لواقعها وصحيحة ويقوم بتحديثها بشكل فوري لتطابق ما هو متوفر ومعتمد بالفرع، ويلتزم بإبلاغ الطرف الأول عن أي تغيير أو تعديل عليها قبل يومين عمل على الأقل. </p>
    <p>2-يتحمل الطرف الثاني كامل المسؤولية عن الطلبات في الحالات الآتية:</p>
    <p class="p-padding">1. يتحمل الطرف الثاني مسؤولية تعويض العميل عن قيمة التوصيل وذلك في حالة تأخر الطرف الثاني تسليم الطلب للسائق لأكثر من 15 دقيقة. </p>
    <p class="p-padding">2. يقوم الطرف الثاني بتعويض العميل عن قيمة الطلبات التي يتم رفضها أو رفع شكوى عليها من ِقبل العميل، بسبب عدم مطابقة الطلب أو اكتماله أو نظافته أو عدم رضى العميل عنه.</p>
    <p class="p-padding">3- یتعهد التاجر ويضمن أنه المالك أو المرخص له باستخدام العلامة التجارية للمتجر ومحتوى منتجات التاجر وبأنــه لا ینتهــك أي "حقوق ملكية فكرية" للغیر (بمعنى أي براءة اختراع، أو حق طاعة، أو علامة تجارية، أو علامة خدمة، أو تغلف وشكل السلعة، ما في ذلك أي "مظهر وجوهر" مسجل ومملوك للغیر أو اسم تجاري، أو شـعار، أو حق معنوي، أو سـر تجاري، أو غیرها من حقوق الملكية الفكرية)، وبموجب هذه الاتفاقية وخلال مدة نفاذها منح التاجر لتيم حًقا وترخيصا غیر حصري وغیر قابل للإلغاء ومعفى من الرسوم وقابًلا للترخيص الفرعي (أ) لنشــــــر، وعادة إصــــــدار، وتوزع، ونقل، وغیر ذلك من وجوه اسـتخدام اسـم التاجر، وعلاماته التجارية، وعلامات خدمته، وشعاراته، وغیرها من ســـــــمات العلامة التجارة الممیزة (يشـــــــار إلیها مجتمعة بلفظ "علامات التاجر“)، و(ب) لنشـــــر وأداء، وعادة إصـــــدار، وتوزيع، ونقل، وعرض، وتعدیل، وانشـــاء أعمال مشـــتقة، وغیر ذلك من وجوه اســـتخدام واســـتغلال جميع محتوى منتجات التاجر بشــكل تجاري، في كل حالة فيما یتعلق ويتصـل بهذه الاتفاقة (بما في ذلك على سبیل المثال لا الحصر تسويق المنتجات والترويج لها، أو المنتجات الأخرى، أو المواقع الالكترونية الخاصة بالغیر، أو البريد الإلكتروني، أو وسائل التواصل الاجتماعي أو غیرها من الوســائط). يجوز لتيم السماح للعملاء وغیرهم من مستخدمي منصة تيم والغیر لمشاركة ونشر محتوى منتجات التاجر على المواقع الالكترونية والتطبيقات ومنافذ التواصل الاجتماعي الخاصة بهم. </p>
    

    <p> <strong> ثالثاً - الرسوم، السداد والخدمات الإضافية: </strong> </p>
    
    <table class="table table-bordered">
      <thead>
        <tr>
            <th>نوع الرسوم</th>
            <th>قيمة الرسوم</th>
            <th>تاريخ البدء</th>
            <th>تاريخ الانتهاء</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
              عمولة الدفع الإلكتروني<br>
              ورسوم الخدمات
          </td>
          <td>2.5%</td>
          <td>{{ now | date:'dd/MM/yyyy' }}</td>
          <td>{{ oneYearLater | date:'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
          <td>
              عمولة المدفوعات الدولية<br>
              ورسوم الخدمات
          </td>
          <td>3.1%</td>
          <td>{{ now | date:'dd/MM/yyyy' }}</td>
          <td>{{ oneYearLater | date:'dd/MM/yyyy' }}</td>
        </tr>
      </tbody>
    </table>

    <p> <strong> يلتزم الطرف الثاني بالدفع للطرف الأول الرسوم التالية: </strong> </p>
    <p>1-رسوم الخدمة الشهرية.</p>
    <p>2-الضرائب الحكومية: </p>
    <p class="p-padding">أ- تطبق أحكام ضريبة القيمة المضافة وفقا للوائح والأنظمة الُمتبعة بالمملكة العربية السعودية.</p>
    <p class="p-padding">ب- يلتزم الطرف الثاني بتقديم الرقم الضريبي المسجل له للطرف الأول فور التعاقد ويتحمل تبعات عدم تقديمها. </p>
    <p class="p-padding">ج- يتعهد الطرف الثاني في حال كان غير مطالب "معفيا" بإصدار رقم ضريبي وفقا للوائح والأنظمة المطبقة بالمملكة العربية السعودية، بمسؤوليته التامة عن إبلاغ الطرف الأول فور تغير ذلك، ويتحمل كافة تبعات عدم تقديمه الرقم الضريبي فور تاريخ إصداره.</p>
    <p>3- الخدمات الإضافية: </p>
    <p class="p-padding">يقدم الطرف الأول لمشتركيه خدمات إضافية كالتسويق والدعاية وخدمات التصوير للمنتجات المعروضة على المنصة، وذلك ُمقابل أسعار ورسوم إضافية يتم التفاق عليها بين الطرفين تُحدد حسب الخدمة. </p>
    
    <p> <strong> رابعاً - المدة والإنهاء:  </strong> </p>
    <p>مدة هذا العقد هي سنة ميلادية تبدأ من تاريخ توقيعه، وتتجدد لمدة أو مدد مماثلة ما لم يخطر أحد الطرفين الأخر بعدم رغبته في التجديد، كما ويحق لأي من الطرفين إنهاء العقد قبل انتهاء مدته بموجب إشعار كتابي يُرسل بالبريد المسجل للطرف الآخر. </p>
    <p><strong>  خامساً- – الأحكام العامة: </strong></p>
    <p>1-يقر الطرفين بأن هذا العقد هو العقد الوحيد الموقع بينهما ويحل محل كافة الاتفاقيات والمراسلات السابقة سواء الكتابية منها أو الشفهية إن وجدت، وفي حالة تعديل أو إضافة أي بند فيلزم أن يكون ذلك التعديل خطيا وبموافقة من الطرفين. </p>
    <p>2-تتم جميع الإشعارات والمخاطبات الرسمية بين الطرفين من خلال البيانات والعناوين المسجلة بالسجلات التجارية الخاصة بالطرفين والعناوين المسجلة في مقدمة هذا العقد عبر التسليم باليد، أو عن طريق البريد، أو عن طريق البريد الإلكتروني أو عبر واتساب وفي حالة تغيير أي من الطرفين عنوانه يقوم فورا بإشعار الطرف الآخر خطيا.</p>
    <p>3-يخضع هذا العقد بشكل كامل الى الأنظمة واللوائح المتبعة والمعمول بها في المملكة العربية السعودية، أي نزاع ينشأ عنها أو يتعلق بها تتم إحالته وتسويته ودياً خلال مدة ثلاثين يوماً، وفي حال تعذر الوصول الى تسوية ودية فإن المحاكم المختصة بمدينة جدة في المملكة العربية السعودية هي صاحبة الاختصاص بفض النزاع.</p>
    <p>4-حقوق الملكية الفكرية: </p>
    <p class="p-padding"> أ- يوافق الطرف الثاني بموجب هذا العقد على إعطاء الحق للطرف الأول بإستخدام حقوق الملكية الفكرية الخاصة به مثل الشعارات والصور والأسماء والعلامات التجارية ، ويتعهد بتزويد الطرف الأول بأي مستندات والقيام بأي إجراءات تمكن الطرف الأول من إستخدامها في الحملات التسويقية والترويجية التي يقوم بها، كما يتعهد بأنه يملك كافة تلك الحقوق الفكرية ولا ينازعه أحد فيها ويضمن سريان ملكيتها طوال مدة هذا العقد، ويتحمل مسؤولية نشوء أي نزاع يتعلق بها. </p>
    <p class="p-padding">  ب- يخضع الطرف الثاني لإرشادات وتعاليم الطرف الأول فيما يتعلق بإستعماله الشعار الخاص بالطرف الأول أو أي من حقوق ملكيته الفكرية وعليه أخذ موافقة الطرف الأول الخطية قبل استعمالها، سواء كان في حملاته الدعائية أو أي مواد دعائية يقوم بها مثل الملصقات أو المنشورات أو ما يتم إدراجه في المواقع الإلكترونية ومواقع التواصل الإجتماعي. </p>


    <p> <strong> سادساً– نسخ العقد:  </strong> </p>
    <p>1-يقر الطرفان بصحة توقيعهما للعقد سواء كان ذلك التوقيع بشكل يدوي أو إلكتروني. </p>
    <p>2-تم تحريرهذاالعقد بشكل إلكتروني وتم توقيعه من ِقبل المفوضين نظاما عن كل طرف، كما وقام كل طرف من طرفي العقد بإستلام نسخة إلكترونية منه للعمل بموجبها. </p>  

    <br/>
    <br/>
    <br/>
    <table class="table table-bordered">
        <tr>
            <th></th>
            <th>وقع عن الطرف الأول</th>
            <th>وقع عن الطرف الثاني</th>
        </tr>

        <tr>
            <td class="label">الاسم</td>
            <td class="value"></td>
            <td class="value">{{ userDetails.full_name }}</td>
        </tr>

        <tr>
            <td class="label">المنصب</td>
            <td class="value"></td>
            <td class="value">{{ jobTitle }}</td>
        </tr>

        <tr>
            <td class="label">التوقيع</td>
            <td class="value"><img *ngIf="teemSignature" [src]="teemSignature" width="70" /></td>
            <td class="value"><img *ngIf="signatureImage" [src]="signatureImage" width="150" height="80" /></td>
        </tr>

        <tr>
            <td class="label">التاريخ</td>
            <td class="value">{{ now | date:'dd/MM/yyyy' }}</td>
            <td class="value">{{ now | date:'dd/MM/yyyy' }}</td>
        </tr>
    </table>


  </div>


  <p i18n="@@contract.signature">التوقيع:</p>
  <fieldset class="half mb-5" [ngClass]="{ 'has-error': !jobTitle }">
    <input [(ngModel)]="jobTitle" #ctrl="ngModel" placeholder="Job Title" required>
    <p class="field-error" *ngIf="!jobTitle" i18n="@@error.required">* Required</p>
  </fieldset>
  
  <div class="signature-pad">
    <div class="signature-pad--body">
      <canvas #sPad width="900" height="100" style="touch-action: none;" (mouseup)="updatePreview()" (touchend)="updatePreview()"></canvas>
    </div>
  </div>
</div>
<div class="modal-footer">
  <a href="javascript:;" class="tu-btn transparent" (click)="clear()" i18n="@@contract.clear">Clear</a>
  <a href="javascript:;" class="tu-btn blue" (click)="submitContract()" i18n="@@contract.submit">Submit</a>
</div>
